import React from 'react';

class About extends React.Component {

	render(){
	return(
		<div className="about">
			<div className="aboutMe">
				<img className="gravatar" src="https://avatars0.githubusercontent.com/u/7544036?v=4" alt="Ben Gummelt" />
				<div className="profile">
					<h4>Bio:</h4>
					<p>My name is Ben and I have always wanted to bring order and design to the world around me.  As a child i would bring order to the displays at gas stations and supermarkets and with the advent of computers I have found a means to organize and design beautiful things.  My careers have taken me into customer service and project management but my calling has always been with front end design.</p>
					<p>I am a senior frontend engineer for <a href="https://diamond.la/">Diamond.la</a> working on Fox.com and foxnation.com.</p>
					<div className="additionalInfo">
						<div className="skillSection">
							<h4>Skills:</h4>
							<div className="mySkills">
								<table>
									<tr>
										<th>CORE</th>
										<th>LIBRARIES</th>
										<th>TOOLS</th>
									</tr>
									<tr>
										<td>Javascript</td>
										<td>React</td>
										<td>Postman</td>
									</tr>
									<tr>
										<td>SCSS</td>
										<td>Typescript</td>
										<td>Sketch</td>
									</tr>
									<tr>
										<td>HTML5</td>
										<td>Jest</td>
										<td>VSCode</td>
									</tr>
									<tr>
										<td>Node</td>
										<td>Redux</td>
										<td>Slack</td>
									</tr>
									<tr>
										<td>PHP</td>
										<td>React Native</td>
										<td>Visio</td>
									</tr>
									<tr>
										<td>MySQL</td>
										<td></td>
										<td></td>
									</tr>
									<tr>
										<td>MongoDB</td>
										<td></td>
										<td></td>
									</tr>
								</table>
							</div>
						</div>
						<div className="educationSection">
							<h4>Education:</h4>
							<div className="myEducation">
								<ul className="skills">
									<li className="skill bold">Degree:</li>
										<ul>
											<li>Bachelors of Computer Science- California Lutheran University</li>
										</ul>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		)
}
}
export default About;


/** WEBPACK FOOTER **
 ** ./src/components/About.js
 **/